import { render } from "./component-kazn-num.vue?vue&type=template&id=3ad6b320"
import script from "./component-kazn-num.vue?vue&type=script&setup=true&lang=js"
export * from "./component-kazn-num.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-kazn-num.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ad6b320"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ad6b320', __exports__)) {
    api.reload('3ad6b320', __exports__)
  }
  
  module.hot.accept("./component-kazn-num.vue?vue&type=template&id=3ad6b320", () => {
    api.rerender('3ad6b320', render)
  })

}


export default __exports__